import React, { useCallback, useMemo } from 'react';
import { useLoaderData } from 'react-router';
import {
  PageContainer,
  PageContent,
  PageHeader,
} from 'src/components/MainPage/_shared/page';
import { useNewId } from 'src/hooks/isNewId';
import { useActionsAccess } from 'src/hooks/useAuth';
import { useRedirect } from 'src/hooks/useRedirect';
import { useWarehouseIncomesActions } from '../WarehouseIncomesPage/hooks/useWarehouseIncomesActions';
import {
  WarehouseIncomeDetail,
  WarehouseIncomeValues,
} from '../WarehouseIncomesPage/services';
import { WarehouseIncomeForm } from './WarehouseIncomeForm';
import { WarehouseIncomeContent } from './WarehouseIncomeContent';
import { DEFAULT_INCOME_TYPE } from '../constants';
import { WarehouseIncomeNotFound } from './WarehouseIncomeNotFound';

export const WAREHOUSE_INCOMES_ROOT = '/main/incomes';

export const WarehouseIncomePage = () => {
  const initialData = useMemo<WarehouseIncomeValues>(
    () => ({
      warehouseId: null,
      documentDateTime: new Date(),
      type: DEFAULT_INCOME_TYPE,
      comment: '',
      supplierId: null,
      items: [],
    }),
    []
  );

  const { isReadOnly } = useActionsAccess();
  const { isNew } = useNewId();
  const { addWarehouseIncome } = useWarehouseIncomesActions();

  const { data } = useLoaderData() as { data: WarehouseIncomeDetail | null };

  const isMutated = addWarehouseIncome.isSuccess;

  const onSubmit = useCallback(
    async (values: WarehouseIncomeValues) => {
      if (isNew) {
        await addWarehouseIncome.mutateAsync(values);
      }
    },
    [isNew, addWarehouseIncome]
  );

  useRedirect(isMutated, WAREHOUSE_INCOMES_ROOT);

  const title = isNew
    ? 'Добавить акт приёмки'
    : data
    ? `Акт приёмки № ${data.number}`
    : 'Акт приёмки';

  const showHeader = Boolean(data) || isNew;

  const content = isNew ? (
    <WarehouseIncomeForm
      initialValues={initialData}
      isMutated={isMutated}
      onSubmit={onSubmit}
      isReadOnly={isReadOnly}
    />
  ) : data ? (
    <WarehouseIncomeContent data={data} />
  ) : (
    <WarehouseIncomeNotFound />
  );

  return (
    <PageContainer>
      {showHeader && <PageHeader title={title} withBreadcrumbs />}
      <PageContent asPaper={!showHeader}>{content}</PageContent>
    </PageContainer>
  );
};
